/* ===== CATI Pakistan — Scroll Reveal ===== */
export function initScrollReveal() {
  document.body.classList.add('js-reveal');
  revealAllPending();
}

export function revealAllPending() {
  const revealElements = document.querySelectorAll('.reveal:not(.revealed)');
  if (revealElements.length === 0) return;

  const windowHeight = window.innerHeight;
  revealElements.forEach(el => {
    const rect = el.getBoundingClientRect();
    if (rect.top < windowHeight * 0.95 || rect.height === 0) {
      el.classList.add('revealed');
    }
  });

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    revealElements.forEach(el => el.classList.add('revealed'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('revealed');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.05,
    rootMargin: '0px 0px -20px 0px'
  });

  revealElements.forEach(el => {
    if (!el.classList.contains('revealed')) {
      observer.observe(el);
    }
  });
}
